module.exports = __webpack_public_path__ + "static/img/1063_small.f9d4acf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1063_small.png
// module id = aDLy
// module chunks = 1